module.exports = __webpack_public_path__ + "img/new_lingron.29b700a5.png";